/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamsFilter_TeamsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
}>;


export type TeamsFilter_TeamsQuery = { teams: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'TeamConnection', edges: Array<{ __typename: 'TeamEdge', node: { __typename: 'Team', id: string, name: string } }> } };


export const TeamsFilter_TeamsDocument = gql`
    query TeamsFilter_Teams($limit: Int!) {
  teams(limit: $limit, filters: {includeInactive: false}) {
    ... on TeamConnection {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTeamsFilter_TeamsQuery__
 *
 * To run a query within a React component, call `useTeamsFilter_TeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsFilter_TeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsFilter_TeamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTeamsFilter_TeamsQuery(baseOptions: Apollo.QueryHookOptions<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables> & ({ variables: TeamsFilter_TeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>(TeamsFilter_TeamsDocument, options);
      }
export function useTeamsFilter_TeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>(TeamsFilter_TeamsDocument, options);
        }
export function useTeamsFilter_TeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>(TeamsFilter_TeamsDocument, options);
        }
export type TeamsFilter_TeamsQueryHookResult = ReturnType<typeof useTeamsFilter_TeamsQuery>;
export type TeamsFilter_TeamsLazyQueryHookResult = ReturnType<typeof useTeamsFilter_TeamsLazyQuery>;
export type TeamsFilter_TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsFilter_TeamsSuspenseQuery>;
export type TeamsFilter_TeamsQueryResult = Apollo.QueryResult<TeamsFilter_TeamsQuery, TeamsFilter_TeamsQueryVariables>;